/* cspell: disable */
export const salts = {
  test: [
    "ff3J]K<y;kg<U'",
    "'ZDWR3F6fNY",
    'OBalO_=d<r)w',
    'reI*Xc7m^O',
    'a.>zbB2e62K7O',
    '8?;S4z3|)1Maq5Z',
    'UV<j#U2|,sq',
    'm,3EW4bNpkJ@x',
    '0n*},bp8QAv9G',
    '{W1@(J7Z5#C1Jx6',
    '`h)1=zQ!3B',
    '<8!,8l{]oMLfbw<',
    'T5cjl9-Zn,he),q',
    '6}KBybUyk@A>YX',
    'VS|Y2~w87uh&',
    '-Eiu6,SZT@[',
    'Ys%Ixi8yF`dBN',
    '_hX`_!WtELLI=xk',
    "9_a|lG.D>JO'g",
    '%rdfhaF(@|}AG',
    'd^BJF9>d6?',
    'apN_GR0tO10b*',
    'zdec!W-~f3A|B',
    'nlL)^|r)lR}y%t',
    '6xWbCa+Q*PJ4k',
    ')m=eSo{T,6',
    'Ol}Wb(PT*6iuho',
    'aM(i:nW>@sTMB',
    'e>!PmL}Qaj;?c',
    'V6JwDCD~Fhexf',
    'qvYT%O~{Q,y',
    'N_wUa=Q8f=VG_h',
    "n>f4Y2>0'{kII^7",
    'k|@,>PbV~=C*',
    '^[#~Z;SH=tQ',
    ',c0PzdR#!PvQ=.',
    'Du[ok8Zr>_5',
    'ZY=vE*__dRI',
    'h1#DB^7<(^2*',
    'oYf``|:>Nff%Mc#',
    'w!1=k|uk[ltRcw',
    'G~l}aR}|o%',
    'l-<9%!M40b>Xi',
    'ZZE7hUiEr`v',
    'tfnx;UpU&m+NR',
    "'(FNMAoP9xEQ@:",
    'iw)l&S6{T!',
    'I@m99pv771',
    'ZEyW]2OXmv',
    'b.cFE{5Xw+4EOF',
    'EAua37)(~kmU5',
    '-?Kl4v}~H%A1',
    '_86A3F`0Ah#',
    '?_w.x.zUxD[uL',
    ',)%sMXugNg.e?dC',
    'c;Yv,n%2BB]#*',
    '^R3@(}z#B~T)',
    '(~`FrUYkEUv=e?',
    ':FDdtkkPO*@',
    '5j,qT!P9^h}}@+m',
    'ZtIrlMZL#|7SY{',
    'rfeQ&:`]VmzL.W',
    '`7u%Hg4mX~K',
    "'fLnwn.7y-",
    'CS*T9Yhcc*N1)^Q',
    'WSU)htTODIa_*',
    '(=xR~;,s7[',
    'TU|,Fj9~_sB',
    '5sTy7S7z{Rpg1}',
    '-T<}`H+-,9v_>``',
    '%!abdv3:~.3A}a<',
    '-Y-pGU2Ae[',
    'O:,Ak5RaN,I',
    'Fg|)ivYN.+RYN',
    ';=Qh-wr+kWkz',
    'SleyT+]<M8N[pP',
    'b6F<<Q3h=dmApy)',
    'aXQeAC_CCqX',
    ':V#yl>FuMiUl>a',
    'B!?A9I*[pGn',
    'H1OGo39yD=2+[`h',
    '=H;}uc9[G[YS',
    '<zFW!pSWhCL',
    'k|991ahz*!-XR',
    '|2+Uo=4BrPxZO',
    '<DYra,!g3i',
    '40&vVd5UbEd',
    'a7Jo8j:lMR0Q_g',
    '7e<,X)lEfq',
    'y[ZwGChwEfIdO',
    '_~^tZP]<HQfTm~H',
    'AC`~5d_<E-',
    ",RT'wH;Z6l",
    'i6M,BZ~Z^SL60',
    "g'r|NIum{IV",
    '{S&{1YHX#]5PF',
    '0^#aVH#3_!_[-',
    'VSdkx|lThUp',
    '3CYuF{trceRG>1i',
    'Gl|ft{*#q=n6'
  ],
  online: [
    'E6x(dyRm0Tu,DYj',
    'V7i@JcXHuM9e',
    'A}eSpm#2drq',
    "id}s'YKA#bI9Ws",
    'NjC<duNpXp4zP3',
    'A-D%FmX&a-',
    'cTFi0x|:dIS',
    'CX:(+?;d.R]?r;',
    'tHtT.dFMJc',
    '(0yLsq4`ql',
    '+?i&h<,!k{:q6hH',
    '{~Ng,T#Q!=86Y1',
    '7n2zb.f8e)%0TvF',
    "*('=C.dG~H1jk",
    'kh]Q;3I8),MBvh',
    '?dlEr=I0pF7]MO',
    '>j^V8.5)X7',
    'W88dd8fL!qoDW',
    "Z57#EqHq['3sYJM",
    "'gABfS-+qGrq",
    "SrG=a,t.Y^&'",
    'veR?NoWVFDHV',
    'Svg,]bb60!',
    '*!ix],:WqX',
    '[eX-0zn.:c',
    '!I5L!mUr1<&K',
    'fz<Ij#f.8&',
    '5t9D38f5M:',
    'yKN_#`AzW_A',
    '*Fxf)ae8%D|',
    '+(d>];xsoY07U',
    'lDZ!YAW4Ww#',
    '>)0_TnPtCg',
    'y[ZosvFa|k-Y',
    "3@>wQo]'SSl|r",
    '3P]+-aoQwlT=',
    'i{xfX)s1{q',
    'c{S)9YQN`1kTR',
    'rNhoLqpq?DWm',
    'BqKHjriKPi#7&6l',
    'T&&fv^f0?h7',
    'la)^Ri?n=H?zM0Y',
    '@x~[O9+}4m(8#',
    '`<I2jd+t=fvm;m',
    'lW!w}eMJ&4psSO!',
    'XX@@,r5u#qOTA',
    'el4I0F+Vc9',
    'ED)s{5YB^+r',
    "=yT`'2u%oxq",
    '^I&CRDz`1d~AgpZ',
    '#NF#)|E{S5`D',
    'K{l~8NyC.+.',
    '`lmpMRp-}<',
    'HA8g4S.5,Y+>Vl',
    'Y;VGwBn,DG',
    'lR^>6OWif#4<.',
    "Dr(D^'Cvy4G'",
    'znfmYvAn]B`l',
    'TWnXc!ICESFU',
    '94kfl(CB0sA:Z',
    'iVyUx|t@GCJ>!*=',
    'zFvMMkOsa9li!y',
    ':Nk[vTB@~*Q%Hc=',
    'u-*Zm.AS<{s',
    '>u&]Jhe%`e%f',
    "2kSg#>jpZa<%y'",
    'rD`hWQxgy-VbQ,',
    'J*3hjId@u>Pw[',
    'fa7:4oyWp*rNV',
    'oH#*7@l[uQ5mHD',
    'bZ}XaRHB=n',
    '}}XU7e!@!{8',
    '<fNa90.:@Ye|9[',
    'g7_;-CJik9',
    'uC;M3G_R2{Z}a@',
    'dFq%!96+`12l}il',
    'DjS>dNlW#^6AzF',
    "~I6YNdRo'!e",
    '3PI&W5aJVJs%t7|',
    "EzEh[lrnn'~&",
    'g]jtb|0y^.',
    'us+6aD|MD(LN',
    "fX{'WY*zXM-5P",
    ',m,ab#xc=H',
    "gwI5-'z5tOx",
    'HT+=qkIE!lfBy3',
    '_fgTLSjTKvaKyOh',
    '?Jx!e3]xD}',
    "5Bk`Bd']2evp}Q-",
    "uV1`*TVY[K'",
    'Pb2#4YFzi!s]x',
    '10yh;M)H*I',
    '#tJT64|M;ncn`P',
    'W}7&q=p:LYnX*',
    "sq[N&_p'F%",
    '#n@Rk^,w9E',
    'DoaBZ8TP>p40rY',
    "Q)EDX);UJ',3",
    'uk:{5(Pp.P)EJ',
    '=)~1u[k;Fa.'
  ]
}

export const saltsType2 = [
  '7}]B[d}37}v8E-)',
  ']%H,c_!b9^G79rj',
  '5&7724:A2RV,*}1',
  ',7y,7f3^Y72;*b-',
  ')bD|b%*c}&3wu`2',
  ']_F|{_gF1;&[V8Q',
  'C]-Z,*E*6D*Msg5',
  '9142|jb.n.[T6j|',
  '*&T,&3RawH*m*8]',
  '92;~7&jnK92f1x4',
  'Hr_,T?776G4#6%4',
  "d'-N:7yKZ(fd^|%",
  "kPY&676PRY'@[CK",
  "4^NYf7'|,22AUAV",
  ',3M3JU8%639!.&{',
  '34VVQVVXG84!*~Q',
  '%]j6225:^]{ms4p',
  "9;;.M'2XWxz86U8",
  '{7u.!~4((k@C9w7',
  '7),6!WV892@x@yA',
  '|y*Hq3dq_^PR~?1',
  '!b&5x@r7,28.1!.',
  'E,)@%#~}6HM5:#p',
  '5u6H@3@h:m46n75',
  'dYf~3%,6@kT6Gu9',
  "nX6EU)31.'|1b?t",
  "G;`4b]2'7P}a,38",
  '62-9`5v]@N_:)1K',
  ")P@(~2}'6T4Am`B",
  '?SPC|S381~26[33',
  "1@yDE#G2G2#@6'1",
  '_4}!41Q8:k6cG6z',
  'jtv?52:448hw1)d',
  '.U@z@`]T3)6^748',
  '49&UX6419417:w-',
  '}B{Gnw92G;8)agE',
  '615R.EH3.*f;8K4',
  '~1VUC;922%,@}E^',
  "8;?m1'Y}rbC#!g_",
  '6_5QQ7p]j_&M98A',
  "~2:C|'5^3b96426",
  'e71(^TG8`K35b;{',
  '.!%Qp?5@!p?`W9e',
  '1e51D4QK[b2389s',
  "f?'912}]3'5Z|!:",
  ')aAK*[,B%JW9`]9',
  'Z@14-(-6&Q7^y|V',
  'B71:!~5@67`59@Y',
  '25Zg(,#t1`;19yJ',
  '(B6479Z6332tY4?',
  'p)18s7ga32j5[1{',
  'K49(`t2p}2(r757',
  '2e}8416MJ6.E@51',
  'h|7v989D,;8}-}2',
  '2A3`5~T18~QM66Q',
  'R.11j95(}^67.67',
  '4HD,j1&3`T3{V{8',
  'w3mSf,G_UC]_76_',
  '&8P9K,?k5a}ENYY',
  'n[!}5--5[]91~2[',
  "{T4('5397|Gj.m]",
  '%{@47um41A87f{8',
  'Kr}{*V6Ka`^|382',
  '#K3k4~8~53;~9:,',
  '1qG4X{*TM93849A',
  '@65*nMJ(Uun.z4,',
  '2j7B5?Z.6X9r55w',
  'd68U36qm`21(-M7',
  '1HQ1722X~^!3P77',
  "416-9y5z%p'63x?",
  '_!4]YuAc^m{2?|x',
  ",:-G5:8%s4#6#'7",
  "s'?329H|!44,h)1",
  '1n_9U.{&6B974*]',
  '*8T.J,;%-7-Y&56',
  'K~4j%%3378D[C%!',
  "`3|9F2-;'JS24[,",
  ',PQ^1@~6&W@S[*8',
  'T)DYN41K98*?Hm.',
  'WA571w~Fc#92_{?',
  "r_f7`#U8WkT55'#",
  '44)45;xVPkgN-;s',
  '2:[&@:D98C*~b?^',
  '2`27_x1mW43*w]p',
  '5fg1?}9x15-5;S:',
  '3C6`668H4xZ9417',
  '5*_3dg4ph53@Aa8',
  "^-3)z9%Zy:2,'8}",
  '_e}2y%]?.%!7sb@',
  '21`-1Eb,6q4V9]E',
  "p66n6_gr817z'y'",
  'U(_545&pUd4)mpU',
  '4#9A93q2d24!71K',
  ':H{-Xv)2|ch7{88',
  '64h_N{#hB6{NSB%',
  "19Xz6'f*15.8Jza",
  '].765}?2nP!p819',
  'sJ2gF%,2mP*@@85',
  '}9:AQ![@7V82R-X',
  'H6cJ1.HG3|8ae`7',
  'J54*9[f:4[Vc|14',
  'dtX*~N3uDeSx,2Q',
  '76[}D`9|M96~k2e',
  '5.?%3--~M-3,374',
  '`RD-7a1&3r5u}5x',
  "B1)h8[7]YUK9'vc",
  '1*4tR{64#4#MF]^',
  '.%?[J(43u4vV66#',
  ')j8#*5]Q8[15;a4',
  '11s3#RGX3831`5)',
  '#*^4-,fV4u5eG.4',
  'xU33^1.2_jt33ka',
  '%q@s,#a9.25),]9',
  '4Qh1#(`5,1d:d3u',
  '2}e3`@(4|5!T66e',
  '8SG4){eE68|)9]n',
  "'U|jt)@s486@f9^",
  "a2pd6e`'&5j98kB",
  'C_J%w8fYw1##5#9',
  '-7F*472py7y8`[4',
  'Z2(2gY{%zH?9%1,',
  '5DN4SqA3KG!Up;A',
  '227#V57@K3~:_?1',
  '64,`|K?v93Q#Bf!',
  'x2gG33CW`Dw9^UJ',
  '?(}9n?8J!66-T*6',
  ')44N9{2n6[g^5;{',
  '1s468c_%81&7WZ6'
]

export const encryptKeyType2 = [
  '-94dx*1.?1?B9*C',
  'F7_19EH&mC4S@&|',
  '}^r49f1D9,86Qp{',
  '.`5Vw-6Fy4,11`X',
  '115*h1UN;]{^??2',
  "?_!1~3}s&'41't:",
  'cD19Mx.Xt1E[96C',
  '5^2e1B3n28#B-6e',
  '[3(5%~W1`|;4U|7',
  "3x~!-6C)172'#25",
  '36Dh#468DN6;m36',
  'n]67fewYe76:]2h',
  "EX^949mf7z92'^B",
  ':,1;6E#N49c5Q22',
  '9*6N82&}q@:.3P8',
  '.-Y9*DY61b98&M#',
  '%::7?(J])6(6^47',
  '9e7M46;R9#!uD[!',
  'u77e49]N;gQ5.4!',
  '6_3G6`(!U32:&%g',
  'c2m782V?6W!-!%6',
  '!7S]2)133}15(J|',
  '7#u,3)5n_F7,17{',
  '7d55g*n;7KX3N78',
  '91#aUmn(!*_dBs8',
  '3N91[FW?;w&)94?',
  '?6.-9?8K%-D]|7x',
  "@8,D{U9*'1Xu-]5",
  'vgQ!PH3dtqjS9{-',
  '15(2&*8~3Zb82}3',
  '!.pG165*,)*x}`#',
  '_`^6-v45P954!2q',
  'Se5N(F[B6%|Z7f7',
  "4'^,.v!4.'5D;j.",
  'P@AS51fV&#|;(2U',
  "9'#7XU15z8M:@3T",
  '47G2XF1X8:e24k7',
  "691H^d-DqR5--'v",
  '48#2E4a]|7p7x85',
  '99[H8{63!`wHs{8',
  ':;Q@42:f225K1(3',
  '~qKr!r,9_&bD}#G',
  'r`462A4y5;87588',
  '!.)72-8?&?3W7n5',
  "6wQ4e3],_px7'4|",
  '4@9~qPM[?)@Cu@m',
  'YS.wm,h#66t3p93',
  'Qw367]18N[_2)#F',
  '|2z|#7,4j1?jz8a',
  '5#B],3:2!P1[72v',
  '8}X,&2;@#)!2#87',
  "57`!1!88s('fkT4",
  'DyD3!#~C69SP9b;',
  '3589^][|pX-`UkP',
  '~(^j9!3]4493kd1',
  'e1Xg5|)^!4*Ey57',
  'Eh(8J5y84%7^27X',
  "6Fm[]3:&#@'fQ&6",
  '5:F98k6u:Qs9c9)',
  "7Pc^9V6@w8'p4eV",
  '7{yS72V3n6u9{US',
  'kH61|CNA!2ajPwe',
  "Z3^%'||,tU.z7_}",
  "B^V!:G(3'%k9]1-",
  '98R}8}DR~_d_|94',
  "419g&HX`:(p'Z^'",
  '@|1[8V5[T`4y6}%',
  '~`f5:28^{.rB)}9',
  '5kH4;p7[7;@4^}2',
  '%7S3}|j8)3@Gb?s',
  't59f96KFA|q*267',
  '9@W9&#375}{h2W1',
  "3m4|K36t:B|!c'B",
  '256}%)[.5C?R9`5',
  '2;4`?E?Tj198173',
  ":n*k^'2V3(M2!Mf",
  '4k`71Js#183*#zB',
  'Zmv^u|Qc2#Xj6y6',
  'v*Rju1a48~n[A4W',
  'K8%!Zw7?;}~|ZcK',
  "#4#Ax&@Tk&'EW*4",
  "'Pr[_761_[9&7^[",
  "dr7&'z9Q)R3w;c'",
  '2:![e22g!9J2T56',
  '7A#9[82m{3P9EN:',
  '_w4Q,4553!7762%',
  'UU?B-p25`7(8@nd',
  's#F6j3.)5x71pW2',
  "[t,1Z'S|PZ~5#X,",
  '38v1bW~p?9&47)3',
  '1TRQA{6E7938%G#',
  'n6!Ax9Xk4Z!8S]B',
  '98|vD8j}3ezC2U4',
  "73!84:z373t#'D[",
  '9:Q-X6@8Er]4%YU',
  '|!}T@S-?z~%5K8T',
  'w:N*_jb5_p7&274',
  'h5|9t`h)9-kW|f,',
  '8)8|3ND3,q`kf*7',
  "44@'-76f3yb!Zt9",
  '4)Y3(e&]3DK38u6',
  'UAA]*@T;3g`a#;_',
  '7?@9d;aun9C~B6U',
  '~Xg4aN9A|N1p6{,',
  '6*4X)B12q@7*;3_',
  '56711z3]!9(a|JU',
  ']aBxD&N;Y14,B14',
  '(E%P|v&&x9(C|[(',
  ']-.&_]11.215GVg',
  "81t'13?9&2S1(}[",
  '8:-98Eja6,7vz7-',
  ']&VD}3q*8]1T247',
  'X@-A!736XV|W.3@',
  "9Wc}~{&5,1?25'N",
  '9;f%8a6[b19R6wy',
  "(}P3''1q&:3b)Nj",
  '}76}988)8^P7c4%',
  'wa2x~t^[1UWt86b',
  'R.D6k-9:651P4)3',
  '2h#15H9K]8!p61[',
  "4G3'D?5s2n6Ks[{",
  '~7x8A14Y1R-23^F',
  'B!(7n4)a167B951',
  'qd@zW4qzA2`@wy?',
  '_S659|*|q2&1R3x',
  '64H1q515Af{h2S7',
  '19[38])nSy|(|7@',
  '){(]17}U7bHPs7w'
]

export const saltsType3 =
  '*DQka42o|3os+%&<#JFVbl5!>Qz!U$_a_1y5Is~f^cS6fV2)p$(v-VPp:!OO,n>;X0HzW)]T&52{X[hjq#H!(yNR.?[:*cf~%$Kup.w|;X)6=Dltjr8=j*~|[=fi&3n'
